<template>
    <site-img
        v-if="testimonials.length"
        class="md-testimonial template7"
        type="bgImg"
        :src="bgType == 'img' ? suitableImg : ''"
        :style="{ 'background-color': bgType == 'color' ? bgColor : null }"
        dir="width"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
        >
            <div class="title-wrap">
                <div v-if="title" :style="{ visibility: title ? 'unset' : 'hidden' }" v-html="formatFontSize(title, '--mg-title-size')" class="mg-title"></div>
                <Arrows
                    :show="true"
                    :showInMobile="true"
                    :disabled="arrowDisabled"
                    @prev="prev"
                    @next="next"
                />
            </div>
            <div v-if="isMobileSize" class="slide-item">
                <div
                    v-for="(item, index) in renderList"
                    :key="index"
                    class="item"
                    @click="()=>toViewMore(item)"
                >
                    <div class="name" v-html="item.reviewerName"></div>
                    <div class="role" v-html="item.transactionInfo"></div>
                    <div class="desc" v-html="item.reviewContent"></div>
                    <div class="score">
                        <ReviewScore
                            :onlyShowActiveScore="false"
                            :sourceType="item.sourceType"
                            :score="item.reviewRate"
                            :iconSize="14"
                        />
                        <only-client>
                            <span class="time">{{
                                $ft.formatDate(item.reviewTime, 'MMM dd yyyy')
                            }}</span>
                        </only-client>
                    </div>
                    <ReviewSourceLogo
                        :sourceType="item.sourceType"
                        :height="15"
                    />
                </div>
            </div>
            <div class="slide-items" v-else>
                <Slider
                    ref="sliders"
                    @disabled="updateDisabled"
                    @showarrow="updateShowArrow"
                    theme="template7"
                    :config="config"
                    :list="testimonials"
                    :pcHeight="301"
                    :itemPcWidth="395"
                    :itemMobileWidth="330"
                >
                    <template v-slot="{ item }">
                        <!-- slide-item -->
                        <div class="item" @click="()=>toViewMore(item)">
                            <img v-if="item.rmaTrackPixelUrl" class="rma-pixel-img" :src="item.rmaTrackPixelUrl" loading="lazy" />
                            <div class="name" v-html="item.reviewerName"></div>
                            <div
                                class="role"
                                v-html="item.transactionInfo"
                            ></div>
                            <div class="desc" v-html="item.reviewContent"></div>
                            <div class="score">
                                <ReviewScore
                                    :onlyShowActiveScore="false"
                                    :sourceType="item.sourceType"
                                    :score="item.reviewRate"
                                    :iconSize="16"
                                />
                                <only-client>
                                    <span class="time">{{
                                        $ft.formatDate(
                                            item.reviewTime,
                                            'MMM dd yyyy'
                                        )
                                    }}</span>
                                </only-client>
                            </div>
                            <ReviewSourceLogo
                                :sourceType="item.sourceType"
                                :height="15"
                            />
                        </div>
                    </template>
                </Slider>
            </div>
        </module-box>
    </site-img>
</template>

<script>
import common from '../index';
import Slider from '../_components/slider.vue';
import Arrows from '../_components/arrows.vue';
export default {
    mixins: [common],
    components: { Slider, Arrows },
    data: function() {
        return {
            disabled: { prev: false, next: false },
            renderIndex: 0,
            showArrow: false
        };
    },
    computed: {
        renderList({ testimonials, renderIndex }) {
            const index = renderIndex * 3;
            return testimonials.slice(index, index + 3);
        },
        arrowDisabled({
            isMobileSize,
            showArrow,
            disabled,
            testimonials,
            renderIndex
        }) {
            if (testimonials.length <= 3) {
                return { prev: true, next: true };
            }
            if (isMobileSize) {
                return {
                    prev: renderIndex === 0,
                    next: renderIndex === Math.ceil(testimonials.length / 3) - 1
                };
            }
            return showArrow ? disabled : { prev: true, next: true };
        },
        config({ autoPlay, delayTime, speed }) {
            return {
                autoPlay,
                interval: delayTime,
                speed
            };
        }
    },
    methods: {
        prev() {
            if (this.isMobileSize) {
                this.renderIndex--;
            } else {
                this.$refs.sliders.prev();
            }
        },
        next() {
            if (this.isMobileSize) {
                this.renderIndex++;
            } else {
                this.$refs.sliders.next();
            }
        },
        updateDisabled(disabled) {
            this.disabled = disabled;
        },
        updateShowArrow(show) {
            this.showArrow = show;
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-testimonial.template7 {
    padding: 0 50px;
    .rma-pixel-img{
      display: block;
        width: 0;
        height: 0;
    }
    .mg-container {
        width: calc(100% - 200px);
        @include media-1680 {
            width: 1180px !important;
        }
    }
    .title-wrap {
        display: flex;
        flex-direction: row;
        padding-bottom: 25px;
        justify-content: space-between;
        position: relative;
        align-items: baseline;
        @include media-600 {
            padding-bottom: 20px;

            .mg-title {
                font-size: 16px !important;
                margin-bottom: 0;
            }
        }

        .mg-title {
            padding-bottom: 0;
            margin: 0;
        }

        &.no-under-line {
            &::after {
                display: none;
            }
        }

        h2 {
            font-family: var(--mg-title-font);
            font-size: var(--mg-title-size);
            color: var(--mg-title-color);
            text-align: var(--mg-title-align);
            line-height: var(--mg-title-line-height);
            letter-spacing: var(--mg-title-letter-spacing);
            margin-right: 20px;
            width: 100%;

            @include media-600 {
                font-size: var(--mg-title-size-mobile) !important;
                line-height: var(--mg-title-line-height-mobile) !important;
                letter-spacing: var(--mg-title-letter-spacing-mobile);
            }
        }
        .arrow-comp {
            .iconfont {
                height: 24px;
            }
        }
    }

    .slide-items {
        position: relative;
        padding: 0 15px;
    }

    .sliders-comp.template7 {
        padding: 0;

        ul {
            border-top: 1px solid #e3e3e3;
        }
    }

    .slide-item {
        .item {
            width: 100%;
            height: 100%;
            padding: 57px 50px;
            border-bottom: 3px solid transparent;
            cursor: pointer;

            @media (min-width: 691px) {
                &:hover {
                    border-color: #191919;
                    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.05);
                }
            }
        }

        .name {
            font-size: 16px;
            font-weight: 700;
            color: #191919;
            line-height: 16px;
            @include ellipsis();
            margin-bottom: 10px;
        }

        .role {
            font-weight: 400;
            font-size: 12px;
            line-height: 12px;
            color: #505050;
            height: 27px;
            @include webkitBox(2);
        }

        .desc {
            font-family: var(--font-medium);
            position: relative;
            margin-top: 20px;
            font-weight: 500;
            font-size: 14px;
            line-height: 24px;
            color: #191919;
            height: 68px;
            @include webkitBox(3);

            &:before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 55px;
                height: 48px;
                opacity: 0.5;
                background-image: url(//static.chimeroi.com/site/images/quot.png);
                background-repeat: no-repeat;
                background-position: 0 0;
                background-size: 55px 48px;
                z-index: -1;
            }
        }

        .score {
            margin-top: 20px;
            margin-bottom: 26px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            color: #505050;
        }
    }

    @media (max-width: 690px) {
        padding: 0;

        .sliders-comp.template7 {
            ul {
                border-top: none;
            }
        }

        .title-wrap {
            .title {
                padding-left: 15px;
            }
        }

        .slide-item {
            .item {
                padding: 30px 17px 5px;
                border-top: 1px solid #e3e3e3;
                font-size: 14px;
                border-bottom: none;
                height: 182px;
            }

            .name {
                margin-bottom: 5px;
            }

            .role {
                height: 12px;
            }

            .score {
                margin-bottom: 5px;
            }

            .desc {
                margin-top: 15px;
                font-weight: 400;
                font-size: 12px;
                line-height: 18px;
                height: 36px;
                @include webkitBox(2);
                background-size: 26px 22px;
            }
        }
    }
}
</style>
